import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=f2d38442&"
import script from "./SettingsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPopup.vue?vue&type=style&index=0&id=f2d38442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports